import React, { Component } from 'react';
import './App.css';
import { Link } from "react-router-dom";
import QuoteBubble from "./quotes/QuoteBubble";
import Blog from "./blog/Blog";

class About extends Component {
	render() {
		return (
			<div className="nf-page">
				<div className="nf-page-head">
					<p className="nf-eyebrow">For the insatiable reader</p>
					<h1>Stories worth losing sleep over.</h1>
				</div>

				<div className="nf-two-col">
					<div>
						<p className="site-text">
							Newfangle Press publishes bold, strange, and unforgettable fiction from voices
							worth discovering.
						</p>
						<p className="site-text">
							Horror. Romance. Thrillers. Stories of the living, the dead, and everyone making
							questionable decisions in between.
						</p>
						<Link to="/catalog" className="nf-entry-link">
							Find your next book &rarr;
						</Link>
					</div>
					<div>
						<QuoteBubble />
					</div>
				</div>

				<h2 className="nf-subhead">From the Press</h2>
				<Blog />
			</div>
		);
	}
}

export default About;
